module.exports = __webpack_public_path__ + "static/img/4016_phase_function_Paper_Points.8a9fce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4016_phase_function_Paper_Points.png
// module id = hnsU
// module chunks = 0